import React from "react";

const Head = () => {
  return (
    <div className="Head">
      <a href="./">
        <h1>
          Hamro<span>Drink</span>
        </h1>
      </a>
    </div>
  );
};

export default Head;
